import React, { useState, useEffect } from 'react'
import {
  TopBar,
  TopBarSection,
  TopBarLinkContainer,
  Dropdown,
  DropdownItem,
  NavLink
} from '@duik/it'
import HeaderContainer from '../UI/HeaderContainer'
import cls from '../styles/Header.scss'
import Dashboard from '../Dashboard/Dashboard'
import HaulsKpiTable from '../Dashboard/HaulsKpiTable/HaulsKpiTable'
import HaulGraphs from 'Dashboard/HaulGraphs/HaulGraphs'
import Projects from '../Projects/Projects'
import ProcoreSettings from '../Projects/ProcoreSettings'
import ActiveNow from 'ActiveNow/ActiveNow'
import Contacts from '../Contacts/Contacts'
import Hauls from '../Hauls/Hauls'
import Loads from '../Hauls/Loads/Loads'
import Sites from '../Sites/Sites'
import { Switch, Route } from 'react-router-dom'
import SmConfirmModal from '../UI/SmConfirmModal'
import ProfileModal from './ProfileModal'
import { useLogoutModal, useProfileModal } from './Shared/hooks'
import { LeftSideColor, colors } from '../UI/TableItem'
import { connect } from 'react-redux'
import { getSites } from '../Sites/Store/actions'
import { getHauls } from '../Hauls/Store/actions'
import { getContacts } from '../Contacts/Store/actions'
import { getProjects } from '../Projects/Store/actions'
import { getMaterials } from '../Materials/Store/actions'
import { getActiveNow } from '../ActiveNow/Store/actions'
import { getDrivers } from '../Drivers/Store/actions'
import { getDispatches, getDriverDispatches } from '../Dispatches/Store/actions'
import { getReports } from '../Reports/Store/actions'
import { getCompany } from '../Companies/Store/actions'
import { bindActionCreators } from 'redux'
import LoadingIcon from '../components/LoadingIcon'
import { getUserData } from '../Store/actions'
import HeaderMobile from './HeaderMobile'
import Dispatches from '../Dispatches/Dispatches'
import DispatchTrucks from '../Dispatches/DispatchTrucks'
import Reports from '../Reports/Reports'
import ReportDetail from '../Reports/ReportDetail'
import { StyledTabItem, NavBarMenuDivider, Logo, LoadingContainer } from './styles'
import { useHistory } from 'react-router-dom'
import MenuIcon from '@material-ui/icons/Menu'
import Tickets from 'Tickets/Tickets'
import TicketsExport from 'Tickets/TicketsExport'

const Header = props => {
  const [activeTab, setActiveTab] = useState('')
  const { logoutModal, handleLogoutModal } = useLogoutModal()
  const { profileModal, handleProfileModal } = useProfileModal()
  const history = useHistory()

  useEffect(() => {
    if (props.location.pathname.includes('/app/hauls')) {
      setActiveTab('hauls')
    }

    if (props.location.pathname.includes('/app/projects')) {
      setActiveTab('projects')
    }
    switch (props.location.pathname) {
      case '/app/active':
        setActiveTab('active')
        break
      case '/app/dashboard':
        setActiveTab('dashboard')
        break
      case '/app/hauls':
        setActiveTab('hauls')
        break
      case '/app/contacts':
        setActiveTab('contacts')
        break
      case '/app/sites':
        setActiveTab('sites')
        break
      case '/app/dispatches':
        setActiveTab('dispatches')
        break
      case '/app/reports':
        setActiveTab('reports')
        break
      case '/app/tickets':
        setActiveTab('tickets')
        break
      default:
        break
    }
  }, [props, props.match.params, props.location.pathname])

  const navTabs = [
    { title: 'Active Now', tabName: 'active', route: '/app/active' },
    {
      title: 'Dashboard',
      tabName: 'dashboard',
      route: '/app/dashboard',
      featureRestriction: 'dashboard'
    },
    { title: 'Projects', tabName: 'projects', route: '/app/projects' },
    { title: 'Hauls', tabName: 'hauls', route: '/app/hauls' },
    { title: 'Contacts', tabName: 'contacts', route: '/app/contacts' },
    { title: 'Sites', tabName: 'sites', route: '/app/sites' },
    {
      title: 'Dispatches',
      tabName: 'dispatches',
      route: '/app/dispatches',
      featureRestriction: 'dispatch'
    },
    { title: 'Reports', tabName: 'reports', route: '/app/reports', featureRestriction: 'reports' },
    { title: 'Tickets', tabName: 'tickets', route: '/app/tickets', featureRestriction: 'tickets' }
  ]

  const { isFinishedLoadingData, userData } = props

  const NavTab = ({ title, tabName, route }) => (
    <StyledTabItem
      className={activeTab === tabName ? 'active' : null}
      Component={NavLink}
      onClick={() => history.push(route)}
      key={title}
    >
      {title}
    </StyledTabItem>
  )

  const navTabItems = navTabs.map(item => {
    if (
      !item.featureRestriction ||
      (item.featureRestriction && userData.companyFeatures.includes(item.featureRestriction))
    ) {
      return NavTab(item)
    }
  })

  const MenuButton = ({ handleToggle }) => (
    <MenuIcon htmlColor="white" onClick={handleToggle} style={{ paddingTop: '2px' }} />
  )

  useEffect(() => {
    Promise.all([
      props.getSites(),
      props.getMaterials(),
      props.getHauls(),
      props.getContacts(),
      props.getProjects(),
      props.getActiveNow(),
      props.getDrivers(),
      props.getDispatches(),
      props.getDriverDispatches(),
      props.getReports(),
      props.getCompany()
      // props.getUserData()
    ])
  }, []) //eslint-disable-line

  return props.screenType === 'desktop' ? (
    <HeaderContainer>
      <TopBar>
        <TopBarSection>
          {isFinishedLoadingData ? (
            <Dropdown
              className={cls.dropdownFilter}
              ButtonComponent={MenuButton}
              position="bottom"
              closeOnOptionClick
            >
              <DropdownItem
                onClick={() => {
                  handleProfileModal()
                }}
              >
                View Profile
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  handleLogoutModal()
                }}
              >
                Logout
              </DropdownItem>
            </Dropdown>
          ) : (
            <MenuIcon htmlColor="white" />
          )}

          <Logo src={require('../assets/logo-02.svg')} alt="logo" />
          <NavBarMenuDivider />
          <TopBarLinkContainer className={cls.links}>{navTabItems}</TopBarLinkContainer>
        </TopBarSection>
      </TopBar>
      {!isFinishedLoadingData && (
        <LoadingContainer>
          <LoadingIcon />
        </LoadingContainer>
      )}
      {isFinishedLoadingData && (
        <Switch>
          {userData.companyFeatures.includes('dashboard') && (
            <Route
              exact
              path="/app/dashboard"
              render={routeProps => <Dashboard {...routeProps} />}
            />
          )}
          {userData.companyFeatures.includes('dashboard') && (
            <Route
              exact
              path="/app/dashboard/:projectNumber/hauls"
              render={routeProps => (
                <HaulsKpiTable projectList={props.projects.projectList} {...routeProps} />
              )}
            />
          )}
          {userData.companyFeatures.includes('dashboard') && (
            <Route
              exact
              path="/app/dashboard/:projectNumber/hauls/:haulId/graphs"
              render={routeProps => (
                <HaulGraphs projectList={props.projects.projectList} {...routeProps} />
              )}
            />
          )}

          <Route exact path="/app/projects" render={routeProps => <Projects {...routeProps} />} />
          <Route
            exact
            path="/app/projects/procore-settings"
            render={routeProps => <ProcoreSettings {...routeProps} />}
          />
          {/* <Route
            exact
            path="/app/projects/import-projects"
            render={routeProps => <ImportProjects {...routeProps} />}
          /> */}
          <Route exact path="/app/hauls" render={routeProps => <Hauls {...routeProps} />} />
          <Route
            exact
            path="/app/hauls/:projectNumber"
            render={routeProps => <Hauls {...routeProps} />}
          />
          <Route
            exact
            path="/app/hauls/:projectNumber/loads/:id"
            render={routeProps => <Loads {...routeProps} />}
          />
          <Route path="/app/active" render={routeProps => <ActiveNow {...routeProps} />} />
          <Route path="/app/contacts" render={routeProps => <Contacts {...routeProps} />} />
          <Route path="/app/sites" render={routeProps => <Sites {...routeProps} />} />
          {userData.companyFeatures.includes('dispatch') && (
            <Route
              exact
              path="/app/dispatches"
              render={routeProps => <Dispatches {...routeProps} />}
            />
          )}
          {userData.companyFeatures.includes('dispatch') && (
            <Route
              path="/app/dispatches/:id"
              render={routeProps => <DispatchTrucks {...routeProps} />}
            />
          )}
          {userData.companyFeatures.includes('reports') && (
            <Route exact path="/app/reports" render={routeProps => <Reports {...routeProps} />} />
          )}
          {userData.companyFeatures.includes('reports') && (
            <Route
              path="/app/reports/:id"
              render={routeProps => <ReportDetail {...routeProps} />}
            />
          )}
          <Route exact path="/app/tickets" render={routeProps => <Tickets {...routeProps} />} />
          <Route
            exact
            path="/app/tickets/export"
            render={routeProps => <TicketsExport {...routeProps} />}
          />
        </Switch>
      )}
      {logoutModal && (
        <SmConfirmModal
          heading="Log out"
          text={`Are you sure you want to log out ${props.userData.email}?`}
          onCloseClick={handleLogoutModal}
          onOKClick={props.logout}
          confirmButtonType="secondary"
          confirmName="Log out"
        />
      )}
      {profileModal && (
        <ProfileModal profileModalToggle={handleProfileModal} userData={props.userData} />
      )}
    </HeaderContainer>
  ) : (
    <>
      <HeaderMobile activeTab={activeTab}></HeaderMobile>
    </>
  )
}

const mapStateToProps = state => {
  return {
    isFinishedLoadingData:
      !state.sites.loading &&
      !state.materials.loading &&
      !state.hauls.loading &&
      !state.contacts.loading &&
      !state.projects.loading &&
      !state.drivers.loading &&
      !state.activeNow.loading &&
      !state.user.loading &&
      !state.dispatches.loading &&
      !state.reports.loading,
    userData: state.user.userData,
    screenType: state.ui.screenType
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSites,
      getHauls,
      getContacts,
      getProjects,
      getMaterials,
      getActiveNow,
      getUserData,
      getDrivers,
      getDispatches,
      getDriverDispatches,
      getReports,
      getCompany
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Header)
